import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { DiagnosticoCliente, Etapa } from '../diagnostico/Diagnostico.entity';
import { DiagnosticoclienteHttpService } from '../diagnosticocliente-http.service';
import { MatTableDataSource } from '@angular/material';
import { User } from '../shared/user.model';
import { UserService } from '../shared/user.service';
import { MatDialogRef, MatDialog} from '@angular/material/dialog';
import { DiagnosticosEdicionComponent } from '../diagnosticos-edicion/diagnosticos-edicion.component';
import { NavegacionService } from '../sidenav.service';

@Component({
  selector: 'app-diagnosticos-lista',
  templateUrl: './diagnosticos-lista.component.html',
  styleUrls: ['./diagnosticos-lista.component.css']
})

export class DiagnosticosListaComponent implements OnInit {

  nuevo = false;
  _currentClient: User = null;
  @Input('currentClient')
  set currentClient(value: User) {
      // console.log('En menu set cambio ciclo.');
      // console.log(value);
      this._currentClient = value;
  }

  diagnostico: DiagnosticoCliente[] = [];
  dataSource: MatTableDataSource<DiagnosticoCliente>;
  diagnosticoSeleccionado: DiagnosticoCliente = null;
  displayedColumns = ['Descripcion'];

  constructor(
    private DiagnosticoClienteSrv: DiagnosticoclienteHttpService,
    public navegacionServices: NavegacionService,
    private _router: Router ,
    public userService: UserService ,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.buscardiagnosticos(false);

  }

  private buscardiagnosticos(posicionarSeEnUno: boolean) {
    if (this._currentClient !== null) {
      this.DiagnosticoClienteSrv.getDiagnosticoClientebyID(this._currentClient.clienteID).subscribe(diagnosticos => {
        this.diagnostico = diagnosticos;
        this.dataSource = new MatTableDataSource(this.diagnostico);
        // console.log('En el init de diagnostico lista');
        // console.log(this.diagnostico);
        if (this.diagnostico.length === 0) {
          this.Agregar();
        }
        // console.log(this.diagnostico.length);
        if (this.diagnostico.length === 1 && posicionarSeEnUno) {
          // console.log(this.diagnostico[0]);
          this.Editar(this.diagnostico[0]);
        }
      });
    } else {
      this.userService.getUserClaims().subscribe((data: any) => {
        this._currentClient = data;
        this.DiagnosticoClienteSrv.getDiagnosticoClientebyID(this._currentClient.clienteID).subscribe(diagnosticos => {
          this.diagnostico = diagnosticos;
          this.dataSource = new MatTableDataSource(this.diagnostico);
          // console.log('En el init de diagnostico lista');
          // console.log(this.diagnostico);
          if (this.diagnostico.length === 0) {
            this.Agregar();
          }
          // console.log(this.diagnostico.length);
          if (this.diagnostico.length === 1 && posicionarSeEnUno) {
            // console.log(this.diagnostico[0]);
            this.Editar(this.diagnostico[0]);
          }
        });
      });
    }
  }

  diagnosticoSelect(diag: DiagnosticoCliente) {
    this.diagnosticoSeleccionado = diag;

  }

  EstaSeleccioando(diag: DiagnosticoCliente) {
    if ( this.diagnosticoSeleccionado ) {
      return this.diagnosticoSeleccionado.diagnosticoID === diag.diagnosticoID;
    } else {
      return false;
    }
  }

  Agregar() {
    // this._router.navigate(['/DiagnosticosEdicionComponent', 'agregar',  0]);
    // , { height: '400px', width: '600px', }

     const dialogRef = this.dialog.open(DiagnosticosEdicionComponent );
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      if (result !== undefined && result.diagnosticoID !== undefined) {
        this.navegacionServices.currentDiag = result.diagnosticoID;
        if (this.diagnostico !== undefined  && this.diagnostico.length > 2) {
          this.navegacionServices.setEtapabyId(1);
          this._router.navigate(['/cuestionario']);
        } else {
          this._router.navigate(['/diagnostico']);
      }
    } else {
      this.buscardiagnosticos(true);
    }
    });

  }

  Filtrar(filtro: string) {

    this.DiagnosticoClienteSrv.FindbyDescripcion(this._currentClient.clienteID, filtro).subscribe( diagnosticos => {
      this.diagnostico = diagnosticos;
       this.dataSource = new MatTableDataSource(this.diagnostico);
    });
   }

  Editar(diagnosticoseleccionado: DiagnosticoCliente) {
    this.navegacionServices.currentDiag = diagnosticoseleccionado;
    // console.log('diagnostico seleccion');
    // console.log(this.diagnostico.length);
    if (this.diagnostico !== undefined  && this.diagnostico.length > 2) {
      // console.log('Entre directo');
      // this.navegacionServices.setEtapabyId(1);
      this.navegacionServices.buscarEtapaDiagnostico();
      this._router.navigate(['/cuestionario']);
    } else {
      this._router.navigate(['/diagnostico']);
  }
  }

}




// WEBPACK FOOTER //
// ./src/app/diagnosticos-lista/diagnosticos-lista.component.ts